const mEditionAccountChangePassword = {
  mEditionAccountChangePassword: {
    alerts: {
      updateChangePassword: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'La contraseña se actualizo exitosamente.'
      }
    },

    inputs: {
      confirm_password: {
        label: 'Confirmar Contraseña Nueva'
      },

      previous_password: {
        label: 'Contraseña Actual'
      },

      proposed_password: {
        label: 'Contraseña Nueva',
        message: '* Mínimo: 8 caracteres, una letra minúscula, una mayúscula y un número.'
      }
    },

    title: 'Cambiar Contraseña',

    validation: {
      confirm_password: {
        required: 'Confirmar la contraseña es requerido.',
        sameAsPassword: 'La contraseña no coinciden.'
      },

      previous_password: {
        minLength: 'La longitud mínima permitida es de 8 caracteres.',
        required: 'Contraseña actual es requerida.'
      },

      proposed_password: {
        minLength: 'La longitud mínima permitida es de 8 caracteres.',
        required: 'Contraseña nueva es requerida.',
        valid: 'La contraseña debe contener minúsculas, mayúsculas y números.'
      }
    }
  }
}
export default mEditionAccountChangePassword
